import React, { useState, useEffect, useMemo } from 'react';
import '../ManageComponent.css';
import LeaveStatusCardComponent from '../../../components/LeaveStatusCard/LeaveStatusCardComponent';
import {
  getLeavesRequest,
  getUserData,
  updateApplicationStatus,
} from '../../../services/UserService';
import KeycloakService from '../../../services/KeycloakService';
import { useDispatch, useSelector } from 'react-redux';
import {
  RESET_DATE_RANGE,
  SET_DATE_RANGE,
  SHOW_NOTIFICATION,
  WFHAttribute,
} from '../../../constants';
import PaginationComponent from '../../../components/Pagination/Pagination';
import { Box } from '@mui/system';
import { Grid, Typography } from '@mui/material';
import { NO_LEAVE_REQUESTS } from '../ManageConstants';
import GenericLoader from '../../../components/Loader/GenericLoader';
import GenericFilterDrawer from '../../../components/GenericFilter/GenericFilterDrawer';
import { useLocation } from 'react-router-dom';
import {
  resetFilterDataState,
  setFilterConfig,
  setFilterDataState,
} from '../../../modules/filter/filterAction';
import { checkFilterIconVisibility } from '../../../components/GenericFilter/FilterIconVisibilityCheck';
import { cardComponentCollapse } from '../../../modules/cardState/cardAction';
import { getLeaveTypeList } from '../../../services/LeaveService';
import { getManagerProjects } from '../../../services/UserService';
import { getEmployeesOfManager } from '../../../services/UserService';
import moment from 'moment';

const ManageLeaveRequestsComponent = (props) => {
  const [pageSize, setPageSize] = useState(5);
  const uniqueIds = new Set();
  const [showError, setShowError] = useState(false);
  const dispatch = useDispatch();
  const currentUserId = KeycloakService.getUserDetail();
  const [leaveRequestList, setLeaveRequestList] = React.useState([]);
  const [loader, setLoader] = React.useState(true);
  const [loader1, setLoader1] = React.useState(true);
  const [pageNo, setPageNo] = React.useState(0);
  const [refreshPage, setRefreshPage] = React.useState(false);
  const [resetFilter, setResetFilter] = useState(false);
  const filterState = useSelector((state) => state.filterState);

  const emptyFilterData = {
    employeeName: '',
    employeeId: '',
    leaveId: '',
    leaveName: '',
    status: '',
    isUpdatedByAdmin: false,
    startDate: '',
    endDate: '',
    projectName: '',
  };

  const [totalPage, setTotalPage] = React.useState();
  const [page, setPage] = React.useState(1);
  const [empNameArray, setEmpNameArray] = React.useState([]);
  const [leaveTypeArray, setLeaveTypeArray] = React.useState([]);
  const [options, setOptions] = useState({});
  const [projectArray, setProjectArray] = useState([]);

  useEffect(() => {
    setOptions((prevOptions) => ({
      ...prevOptions,
      employee: empNameArray,
    }));
  }, [empNameArray]);

  const location = useLocation();
  const xyz = new URLSearchParams(location.search).get('xyz');
  const searchString = xyz ? window.atob(xyz) : '';
  const tabType = new URLSearchParams(searchString).get('type');

  const updateApplication = async (templateApplicationResponse) => {
    const updatedApplicationResponse = await updateApplicationStatus(
      templateApplicationResponse,
    );
    if (updatedApplicationResponse.isError === false) {
      setRefreshPage(!refreshPage);
    }
    dipatchNotification(
      updatedApplicationResponse.type,
      updatedApplicationResponse.message,
    );
    return updatedApplicationResponse;
  };

  const filterConfiguration = {
    inputField: [
      [
        ['status', 'Status'],
        [
          ['APPROVED', 'Approved'],
          ['PENDING', 'Pending'],
          ['REJECTED', 'Rejected'],
          ['CANCELLED', 'Cancelled'],
        ],
      ],
    ],
    checkField: [['isUpdatedByAdmin', 'Updated by HR']],
    autoComplete: [['Search Employee', 'employee']],
    dropdownField: [
      // ['Search Employee', 'employee', 'name', 'id'],
      ['Search Project', 'project', 'projectName', 'projectId'],
      ['Leave', 'leave', 'leaveName', 'id'],
    ],
  };

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const getAppliersList = async (userId) => {
    const applierList = await getEmployeesOfManager(currentUserId, '');
    if (Array.isArray(applierList.data)) {
      applierList.data.forEach((item) => {
        const employeeId = item.employeeId;
        const employeeName = item.employeeName;
        if (!uniqueIds.has(employeeId)) {
          uniqueIds.add(employeeId);
          setEmpNameArray((prev) => [
            ...prev,
            { id: `${employeeId}`, name: `${employeeName}` },
          ]);
        }
      });
    }
  };

  const getLeaveName = (request, leaveTypes) => {
    const leaveTypeName = (leaveTypes || []).find(
      (item) => item.id === request.applicationDTO.leaveId,
    );
    request.leaveType = leaveTypeName?.leaveName;
    request.leaveCategoryId = leaveTypeName?.leaveCategoryId;
  };

  const ensureLeaveTypes = async () => {
    if (leaveTypeArray?.length) {
      return leaveTypeArray;
    }
    const year = new Date().getFullYear();
    const newData = await getLeaveTypeList(year);
    const leaveTypes = newData?.data || [];
    setLeaveTypeArray(leaveTypes);
    setOptions((prevOptions) => ({
      ...prevOptions,
      leave: leaveTypes,
    }));
    return leaveTypes;
  };

  const getLeaveRequests = async () => {
    const leaveTypes = await ensureLeaveTypes();
    const leavesRequests = await getLeavesRequest(
      currentUserId,
      filterState,
      filterState.isUpdatedByAdmin,
      pageSize,
      pageNo,
      false,
    );
    if (leavesRequests?.isError === false) {
      setTotalPage(leavesRequests?.data.data.totalPages);
      leavesRequests?.data.data.content.forEach((request) => {
        request.empName = `${request.applicationDTO.empName}`;
        request.approverList =
          request.applicationDTO?.applicationStatusDTOS || [];
        getLeaveName(request, leaveTypes);
      });
      setLeaveRequestList(leavesRequests?.data.data.content);
      setLoader(false);
      setLoader1(false);
    }
    if (leavesRequests.status !== 200) {
      dipatchNotification(leavesRequests.type, leavesRequests.message);
    }
  };

  const getProjects = async () => {
    const projectList = await getManagerProjects(currentUserId, null, null, 0);
    if (projectList?.status === 200) {
      setProjectArray((prevProjects) => [...projectList.data.content]);
      // setProjectArray(projectList.data.content);
      // setOptions({ ...options, leave: newData?.data });
      // const newOptions = {
      //   ...options,
      //   project: [...projectList?.data],
      // };
      // console.log(newOptions, 'newOptions');
      setOptions((prevOptions) => ({
        ...prevOptions,
        project: projectList?.data,
      }));
    } else {
      setProjectArray((prevProjects) => []);
      setOptions((prevOptions) => ({
        ...prevOptions,
        project: [],
      }));
    }
    setLoader1(false);
  };

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setRefreshPage(!refreshPage);
    setLoader(true);
  };

  const handlePageSizeChange = (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    pageChange(null, 1);
    setRefreshPage(!refreshPage);
  };

  const getUserName = async (id) => {
    const empName = await getUserData(id);
    const employeeName = `${empName.data.firstName} ${empName.data.lastName}`;
    dispatch(
      setFilterDataState({ ...filterState, employeeName: employeeName }),
    );
  };

  const resetThings = () => {
    for (let arrayOfArrays of filterConfiguration.dropdownField) {
      setOptions({ ...options, [arrayOfArrays[1]]: [] });
    }
    dispatch(setFilterConfig(filterConfiguration));
    if (tabType !== 'LEAVE') {
      dispatch(resetFilterDataState());
      dispatch({
        type: RESET_DATE_RANGE,
      });
      dispatch(cardComponentCollapse());
    }
  };

  const applyDefaultDateRange = () => {
    if (tabType === 'LEAVE' || (filterState?.startDate && filterState?.endDate)) {
      return;
    }
    const endDate = moment().format('YYYY-MM-DD');
    const startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
    dispatch(
      setFilterDataState({
        ...filterState,
        startDate,
        endDate,
      }),
    );
    dispatch({
      type: SET_DATE_RANGE,
      data: {
        startDate,
        endDate,
      },
    });
  };

  const getLeaveTypeData = async () => {
    await ensureLeaveTypes();
  };

  useEffect(() => {
    resetThings();
    applyDefaultDateRange();
    getProjects();
    getLeaveTypeData();
    getAppliersList();
    setResetFilter(true);
  }, []);

  const temp = useMemo(() => {
    pageChange(null, 1);
    if (filterState?.employeeId && filterState?.employeeName === undefined) {
      getUserName(filterState.employeeId);
    }
  }, [filterState]);

  useEffect(() => {
    if (resetFilter) getLeaveRequests();
  }, [refreshPage, resetFilter]);

  const getOptions = () => {
    return { ...options, project: projectArray };
  };

  return (
    <>
      {loader || loader1 ? (
        <div style={{ height: '70vh', overflow: 'hidden' }}>
          <GenericLoader
            rectAttributes={WFHAttribute}
            showError={showError}
            setShowError={setShowError}
          />
        </div>
      ) : (
        <>
          {checkFilterIconVisibility(
            filterState,
            emptyFilterData,
            leaveRequestList,
            // ) && <GenericFilterDrawer options={options} />}
          ) && <GenericFilterDrawer options={getOptions()} />}
          <Box
            sx={{
              overflow: 'hidden',
            }}
          >
            {leaveRequestList.length != 0 ? (
              leaveRequestList.map((request) => {
                return (
                  <LeaveStatusCardComponent
                    key={request.id}
                    leave={request}
                    leaveStatus={request.applicationDTO.status}
                    updateApplication={updateApplication}
                    variant="manager"
                  />
                );
              })
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '70vh',
                }}
              >
                <div>
                  <Typography>{NO_LEAVE_REQUESTS}</Typography>
                </div>
              </div>
            )}
          </Box>
          {leaveRequestList.length ? (
            <Box className="page-holder">
              <PaginationComponent
                count={totalPage}
                page={page}
                pageChange={pageChange}
                pageSize={pageSize}
                handlePageSizeChange={handlePageSizeChange}
              />
            </Box>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default ManageLeaveRequestsComponent;
